import linkedin from '../images/socials/linkedin.svg';
import github from '../images/socials/github.png';
import messenger from '../images/socials/messenger.svg';
import whatsapp from '../images/socials/whatsapp.svg';
import gmail from '../images/socials/gmail.svg';
import telegram from '../images/socials/telegram.svg';

const SocialInfo = [
  {
    id: 'social-media-2',
    name: 'LinkedIn',
    icon: linkedin,
    link: 'https://www.linkedin.com/in/prionto-abdullah',
  },
  {
    id: 'social-media-3',
    name: 'GitHub',
    icon: github,
    link: 'https://github.com/PriontoAbdullah',
  },
  {
    id: 'social-media-4',
    name: 'Messenger',
    icon: messenger,
    link: 'https://m.me/100009352634103',
  },
  {
    id: 'social-media-5',
    name: 'WhatsApp',
    icon: whatsapp,
    link: 'https://wa.me/8801805486757',
  },
  {
    id: 'social-media-7',
    name: 'Gmail',
    icon: gmail,
    link: 'https://mail.google.com/mail/?view=cm&fs=1&to=prionto71@gmail.com',
  },
  {
    id: 'social-media-8',
    name: 'Telegram',
    icon: telegram,
    link: 'https://telegram.me/+8801805486757',
  },
];

export default SocialInfo;
